<div class="status-container" *ngIf="data">
  <table>
    <tbody>
      <tr>
        <td *ngIf="data.PLANNED">
          <div class="PLANNED_status">PLANNED: {{ data.PLANNED }}</div>
        </td>
        <td *ngIf="data.RUNNING">
          <div class="RUNNING_status">RUNNING: {{ data.RUNNING }}</div>
        </td>
        <td *ngIf="data.OFFICIAL">
          <div class="PLANNED_status">OFFICIAL: {{ data.OFFICIAL }}</div>
        </td>
        <td *ngIf="data.FINISHED">
          <div class="FINISHED_status">FINISHED: {{ data.FINISHED }}</div>
        </td>
        <td *ngIf="data.PUBLISHED">
          <div class="FINISHED_status">PUBLISHED: {{ data.PUBLISHED }}</div>
        </td>
        <td *ngIf="data.DNS">
          <div class="DNS_status">DNS: {{ data.DNS }}</div>
        </td>
        <td *ngIf="data.CLEANED">
          <div class="DNT_status">CLEANED: {{ data.CLEANED }}</div>
        </td>
        <td *ngIf="data.ABANDONED">
          <div class="ABANDONED_status">ABANDONED: {{ data.ABANDONED }}</div>
        </td>
        <td *ngIf="data.DNT">
          <div class="DNT_status">DNT: {{ data.DNT }}</div>
        </td>
        <td *ngIf="data.DNF">
          <div class="DNT_status">DNF: {{ data.DNF }}</div>
        </td>
        <td *ngIf="data.DSQ">
          <div class="DNT_status">DNQ: {{ data.DSQ }}</div>
        </td>
        <td *ngIf="data.FTF">
          <div class="DNS_status">FTF: {{ data.FTF }}</div>
        </td>
        <td *ngIf="data.SCR">
          <div class="DNS_status">SCR: {{ data.SCR }}</div>
        </td>
        <td *ngIf="data['L/SCR']">
          <div class="DNS_status">L/SCR: {{ data['L/SCR'] }}</div>
        </td>
        <td *ngIf="data.FELL">
          <div class="DNS_status">FELL: {{ data.FELL }}</div>
        </td>
        <td *ngIf="data.DISTANCE">
          <div class="DNS_status">DISTANCE: {{ data.DISTANCE }}</div>
        </td>
        <td *ngIf="data.RO">
          <div class="DNS_status">RO: {{ data.RO }}</div>
        </td>
        <td *ngIf="data.BD">
          <div class="DNS_status">BD: {{ data.BD }}</div>
        </td>
        <td *ngIf="data.LB">
          <div class="DNS_status">LB: {{ data.LB }}</div>
        </td>
        <td *ngIf="data.LGO">
          <div class="DNS_status">LGO: {{ data.LGO }}</div>
        </td>
        <td *ngIf="data.LGT">
          <div class="DNS_status">LGT: {{ data.LGT }}</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
